import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { productOptionsPageActions } from '@mkp/product-options/actions';
import { selectActiveTab } from '@mkp/product-options/state';
import { Button, ButtonColor, ButtonSize } from '@mkp/shared/ui-library';
import { PRODUCT_PLATFORM_GROUP_TRANSLATIONS, ProductPlatformGroup } from '@mkp/shared/models';
import { getSwitchedPlatformFrom } from '@mkp/shared/util-product';
import { Store } from '@ngrx/store';

const PLATFORMS: {
  name: ProductPlatformGroup;
  translationKey: string;
}[] = [
  {
    name: ProductPlatformGroup.Jobs,
    translationKey: 'PRODUCT_OFFERING.PLATFORM.JOBS',
  },
  {
    name: ProductPlatformGroup.JobUp,
    translationKey: 'PRODUCT_OFFERING.PLATFORM.JOBUP',
  },
  {
    name: ProductPlatformGroup.JobScout24,
    translationKey: 'PRODUCT_OFFERING.PLATFORM.JOB-SCOUT-24',
  },
];

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDisplaySwitchSharedComponent implements OnChanges {
  readonly jobScoutConfig: Button = {
    color: ButtonColor.Secondary,
    size: ButtonSize.Small,
  };

  @Input({ required: true }) activePlatformGroup!: ProductPlatformGroup;
  @Input() withCreditTab = false;

  @Output() handleSwitchOffering = new EventEmitter();

  switchedPlatform!: ProductPlatformGroup;

  store = inject(Store);

  activeTab$ = this.store.select(selectActiveTab);
  platorms = PLATFORMS;
  readonly translations = PRODUCT_PLATFORM_GROUP_TRANSLATIONS;

  ngOnChanges({ activePlatformGroup }: SimpleChanges): void {
    if (activePlatformGroup.currentValue !== activePlatformGroup.previousValue) {
      this.switchedPlatform = getSwitchedPlatformFrom(this.activePlatformGroup);
    }
  }

  handleSwitchPlatform(platform: ProductPlatformGroup): void {
    if (this.withCreditTab) {
      this.store.dispatch(productOptionsPageActions.setActiveTab({ activeTab: 'products' }));
    }
    this.handleSwitchOffering.emit(platform);
  }

  selectCreditTab() {
    this.store.dispatch(productOptionsPageActions.setActiveTab({ activeTab: 'credits' }));
  }
}
